import { useTranslation } from "react-i18next";

import { Button } from "@digital-services/ui";

import { useOrganizationContext } from "@organization/context/useOrganizationContext";
import { OrganizationStatus } from "@organization/models/OrganizationDetails";

import { useDrawerWithConfirm } from "@hooks/useDrawerWithConfirm";
import PlusIcon from "@icons/plus_16.svg?react";

import { AssociateApplicationForm } from "./AssociateApplicationForm";

interface Props {
  organizationId: string;
  afterCallback?: () => void;
}

export const AssociateApplicationButton = (props: Props) => {
  const { organizationId } = props;
  const { organization } = useOrganizationContext();
  const { t } = useTranslation(undefined, {
    keyPrefix: "organization.application"
  });

  const { showDrawer, hideDrawer } = useDrawerWithConfirm();

  const addApplication = () => {
    showDrawer({
      title: t("add.title"),
      children: (
        <AssociateApplicationForm
          organizationId={organizationId}
          onCancel={() => hideDrawer()}
          onSave={() => {
            hideDrawer();
            if (props.afterCallback) {
              props.afterCallback();
            }
          }}
        />
      )
    });
  };

  return (
    <Button
      disabled={organization.status === OrganizationStatus.InActive}
      icon={<PlusIcon />}
      data-testid="add-application-button"
      variant="primary"
      onClick={addApplication}
    >
      {t("add.label")}
    </Button>
  );
};
